import React from "react";
import { connect } from "react-redux";
import {
  fetchReconciliation,
  fetchReconciliationSettlementById,
  fetchReconciliationSettlements,
} from "../../queries/reconciliation/reconciliationQuery";
import language from "../../language";
import { Table } from "../Table";
import { Modal } from "../Modal";
import icons from "../../constants/icons";
import { getStorage } from "../../utils/storage";
import ProcessReport from "./ProcessReport";
import SingleTransactionView from "../Transactions/SingleTransactionView";

class Settlements extends React.Component {
  state = {
    isLoading: false,
    selectedData: {},
    data: [],
    page: 0,
    limit: 10,
    transaction: {},
  };

  componentDidMount() {
    this.getData(true);
  }

  filtersParams = async () => {
    let { filters = {}, reconciliationPublicId } = this.props;
    const { page, limit } = this.state;

    const { merchantID } = await getStorage("merchantID");

    let params = {
      merchantId: merchantID,
      page,
      size: limit,
      reconciliationPublicId,
    };

    if (filters.type) {
      params.type = filters.type.value;
    }
    return params;
  };

  getData = async (isLoading) => {
    const { defaultLanguage } = this.props;
    const params = await this.filtersParams();

    try {
      this.setState({ isLoading });

      const data = await fetchReconciliationSettlements(
        defaultLanguage,
        params
      );

      this.setState({
        isLoading: false,
        data: data.content,
        totalPageCount: data.totalPages,
        page: data.number,
        limit: data.numberOfElements,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  getDataById = async (settlementId) => {
    const { defaultLanguage, reconciliationPublicId } = this.props;

    const { merchantID } = await getStorage("merchantID");

    try {
      this.setState({ isLoadingById: true });

      const data = await fetchReconciliationSettlementById(defaultLanguage, {
        settlementId,
        reconciliationPublicId,
        merchantId: merchantID,
      });

      this.setState({
        isLoadingById: false,
        transaction: data,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });

    this.getDataById(selectedData.publicId);
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].created_at,
        key: "dateCreated",
        type: "link",
        onPress: (item) => {
          this.handleShowModal("showModal", item.reconciliation.label, item);
        },
      },
      {
        title: language[this.props.defaultLanguage].reconciliation,
        key: "reconciliation.label",
      },
      {
        title: language[this.props.defaultLanguage].batch_number,
        key: "settlementBatch.batchNumber",
        type: "link",
        onPress: (item) =>
          this.handleShowModal("showModal", item.reconciliation.label, item),
      },
      {
        title: language[this.props.defaultLanguage].amount,
        key: "amount",
      },
      {
        title: language[this.props.defaultLanguage].settlement_amount,
        key: "settlementAmount",
      },
      {
        title: language[this.props.defaultLanguage].total_settlement_fee,
        key: "totalSettlementFee",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "settlementBatch.status",
      },
      {
        title: "",
        key: "multiple-actions",
        actions: [
          {
            icon: icons.eye_on,
            title: "View",
            onPress: (item) =>
              this.handleShowModal(
                "showModal",
                item.reconciliation.label,
                item
              ),
          },
        ],
      },
    ];

    return headers;
  }

  render() {
    return (
      <>
        <div className="card-body">
          <Table
            data={this.state.data}
            page={this.state.page}
            limit={this.state.limit}
            totalPageCount={this.state.totalPageCount}
            isLoading={this.state.isLoading}
            handlePagination={this.handlePagination.bind(this)}
            headers={this.returnTableHeaders()}
          />
        </div>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          showHeaderBottomBorder={false}
          size="lg"
          title={language[this.props.defaultLanguage].activities}
        >
          <SingleTransactionView transaction={this.state.transaction} />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(Settlements);
